import React from 'react'
import { StyledIconBox } from './style'

type IconProp = React.ElementType | React.ReactNode

interface IIconBoxProps {
  readonly backgroundColor?: string
  readonly Icon: IconProp
  readonly style?: React.CSSProperties
  readonly size?: number
  readonly className?: string
}

const IconBox: React.FC<IIconBoxProps> = ({ backgroundColor, Icon, style, size, className }) => (
  <StyledIconBox backgroundColor={backgroundColor} size={size} className={className} style={style}>
    {typeof Icon === 'function' ? <Icon /> : Icon}
  </StyledIconBox>
)

export default IconBox
